paceOptions = {
  // Disable the 'elements' source
  elements: false,

  // Only show the progress on regular and ajax-y page navigation,
  // not every request
  restartOnRequestAfter: false
}



// WEBPACK FOOTER //
// /home/mikael/workspace/themes/unify-master/HTML/One-Pages/Architecture/assets/js/plugins/pace-loader.js